import {api} from "../../api/axiosInstance.js";
import {createEffect} from "effector";

export const getDictionariesFx = createEffect()
	.use(async () => {
		return (await api().get('/directory/')).data
	})
